import { render, staticRenderFns } from "./ChangeDefaultPassword.vue?vue&type=template&id=5a4cacc9&"
import script from "./ChangeDefaultPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeDefaultPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports